<template>
  <div class="">
    
  </div>
</template>
<script>

export default {
  name:"",    
  data: () => ({
    hashValue: '',
    loginData: {},
    currentPage: 1,
  }),
  props: {
    tableField:{
      type: Array,
      required: true
    },
    getDataObj: {
        type: Object,
        required: true
    },
    url: {
        type: String,
        required: true
    },
    orgId: {
        type: String,
        required: true,
    }
  },
  watch:{
    orgIdProp: {
        handler(newVal, oldVal){
            console.log(newVal);
        },
        immediate: true,
        deep: true,
    }
  },
  components: {

  },
  created() {
    /* 
      传参  请求数据obj 头部，字段 渲染表格 滚动条插件，滚动加载更多
      请求数据接口
      点击详情 向上传递 this.$emit();  
    */
  },
  mounted() {
    this.hashValue = localStorage.getItem('hashValue');
    this.loginData = JSON.parse(localStorage.getItem('loginData'));

  },
  computed: {
    orgIdProp(){
        return this.orgId;
    }
  },
  methods: {
    Axios({type, url, obj}){
        const randVal = getRandVal();
        const data = {
            loginName: this.loginData.loginName,
            appCode:"runWatchScreen",
            randVal: randVal,
            pwdHash: this.getPwdHash(this.hashValue, randVal),
            token: window.localStorage.getItem('randVal_token'),
            params: {
                pageSize: 50,
                currentPage: this.currentPage,
            }
        };
        if(obj){
            for(let i = 0;i < Object.keys(obj).length; i++){
                data[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
        return new Promise((resolve, reject)=>{
            switch (type) {
                case 'get':
                    axios.get(url, {params:data}).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
                case 'delete':
                    axios.delete(url, {params:data}).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
                case 'post':
                    axios.post(url, data).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
                case 'put':
                    axios.put(url, data).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
                case 'patch':
                    axios.patch(url, data).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
            }
        });
    },
    getData(){
        let dataObj = {
            type: 'get',
            url: 'url',
            obj: {
                feedbackState: null,
                dataType: null,
                target: null,
            }
        }
        this.Axios(dataObj).then((res)=>{
            console.log(res);
            
        });
    }
  }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/layer/layer-table.vue